// Copyright (c) 2020 Deere & Company

import SpaDetailsContainer from '../../tabm/spa-details/state-connector';

export default {
    component: SpaDetailsContainer,
    name: 'SPECIAL_ALLOWANCE_CLAIM',
    path: 'spa/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/tabm/spa.js